// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Mq1A","colMin":"styles_colMin__1dfvn","colCheckbox":"styles_colCheckbox__EryGr"};